import { ToastOptions } from '../hooks/useToast';

// Global toast service that can be called from anywhere
class GlobalToastService {
  private toastCallbacks: ((options: ToastOptions) => void)[] = [];

  // Register a toast callback (called by ToastProvider)
  registerToastCallback(callback: (options: ToastOptions) => void) {
    this.toastCallbacks.push(callback);
  }

  // Unregister a toast callback (called when ToastProvider unmounts)
  unregisterToastCallback(callback: (options: ToastOptions) => void) {
    this.toastCallbacks = this.toastCallbacks.filter(cb => cb !== callback);
  }

  // Show toast from anywhere in the app
  showToast(options: ToastOptions) {
    this.toastCallbacks.forEach(callback => callback(options));
  }

  // Convenience methods
  showSuccess(message: string, autoClose = true, autoCloseDelay = 4000) {
    this.showToast({
      type: 'success',
      message,
      autoClose,
      autoCloseDelay
    });
  }

  showError(message: string, autoClose = true, autoCloseDelay = 4000) {
    this.showToast({
      type: 'error',
      message,
      autoClose,
      autoCloseDelay
    });
  }

  // Predefined messages for common scenarios
  showPaymentFailed() {
    this.showError('Login failed subscription is not active or payment is failed !');
  }
  showLoginFailed() {
    this.showError('Login failed. Please try again.');
  }

  showNetworkError() {
    this.showError('Network error. Please check your connection and try again.');
  }

  showGenericError() {
    this.showError('Something went wrong. Please try again.');
  }
}

// Export a singleton instance
export const globalToastService = new GlobalToastService();
export default globalToastService;

